import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { BroadcastCheckResultDto, CityBroadcastStateDto } from '@upme/contracts';
import { api } from '../../app/api-client';
import { citiesKey } from '../cities/queries';
import { cityBroadcastKey } from './queries';

/** Инвалидирует всё под citiesKey: он префикс для cityBroadcastKey, карточки города и списка (бейдж «Чат»). */
function useInvalidateCities() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: [...citiesKey] });
}

export function useSetBroadcastChat(cityId: string) {
  const invalidate = useInvalidateCities();
  return useMutation({
    mutationFn: (chat: string) =>
      api.put(`admin/cities/${cityId}/broadcast/chat`, { json: { chat } }).json<BroadcastCheckResultDto>(),
    onSuccess: invalidate,
  });
}

export function useCheckBroadcast(cityId: string) {
  const invalidate = useInvalidateCities();
  return useMutation({
    // check обновляет telegramChatTitle — бейдж и шапку надо перечитать.
    mutationFn: () => api.post(`admin/cities/${cityId}/broadcast/check`).json<BroadcastCheckResultDto>(),
    onSuccess: invalidate,
  });
}

export function useSetBroadcastActive(cityId: string) {
  const qc = useQueryClient();
  const invalidate = useInvalidateCities();
  return useMutation({
    mutationFn: (active: boolean) =>
      api.patch(`admin/cities/${cityId}/broadcast`, { json: { active } }).json<CityBroadcastStateDto>(),
    onSuccess: (state) => {
      qc.setQueryData(cityBroadcastKey(cityId), state);
      return invalidate();
    },
  });
}

export function useUnbindBroadcastChat(cityId: string) {
  const invalidate = useInvalidateCities();
  return useMutation({
    mutationFn: async () => {
      await api.delete(`admin/cities/${cityId}/broadcast/chat`);
    },
    onSuccess: invalidate,
  });
}
